import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IonicModule } from '@ionic/angular/lazy';
import { SellGiftVoucherPage } from 'src/app/modals/sell-gift-voucher/sell-gift-voucher.page';

const routes: Routes = [
    {
        path: '',
        component: SellGiftVoucherPage
    }
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        FontAwesomeModule,
        RouterModule.forChild(routes)
    ],
    declarations: [SellGiftVoucherPage]
})
export class SellGiftVoucherPageModule { }
